import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig.js';

const environment = import.meta.env.MODE;

export default {
    originalSongKey: 'ai/input/music-generator/',
    resultSongKey: 'ai/export/music-generator/',
    waveformKey: 'ai/export/music-generator/waveform/',
    historyListType: [17, 21],
    freeLimitType: 'music-generator',
    currentMenuName: 'ai-music-generator',

    coverPath:
        environment === LOCAL
            ? `/public/resource/ai-audio/cover/cover.png`
            : `/app/ai-tools/resource/ai-audio/cover/cover.png`,
    presetPreviewPath: environment === LOCAL ? `/public/resource/ai-audio/` : `/app/ai-tools/resource/ai-audio/`,
    presetListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/ai-audio/presetList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/ai-audio/presetList.json?v=${FJVersionConfig.staticPathVersion}`,
    referencePresetListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/ai-audio/referencePresetList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/ai-audio/referencePresetList.json?v=${FJVersionConfig.staticPathVersion}`,

    recordVideoPath:
        environment === LOCAL
            ? `/public/resource/ai-audio/record/record.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/resource/ai-audio/record/record.mp4?v=${FJVersionConfig.staticPathVersion}`,
};
